<template>
    <b-button variant="light"
              class="border-gray-light"
              v-b-tooltip.hover="title"
              :disabled="disabled || isBusy"
              @click="createProtocol">
        <font-awesome-icon :icon="['fas', 'file-alt']"></font-awesome-icon>
    </b-button>
</template>

<script>
    import { get } from '@/helpers/api';

    export default {
        name: 'ControlBuildProtocolButton',
        props: {
            controlId: { type: Number, required: true },
            activePartId: { type: Number, default: null },
            disabled: { type: Boolean, default: false },
            title: { type: String, default: 'Skapa protokoll' }
        },
        emits: ['created', 'busy'],
        data() {
            return {
                isBusy: false
            };
        },
        computed: {
            protocolUrl() {
                const baseUrl = `/${this.controlId}`;
                return this.activePartId ? `${baseUrl}?partId=${this.activePartId}` : baseUrl;
            }
        },
        methods: {
            async createProtocol() {
                if (this.disabled || this.isBusy) {
                    return;
                }

                this.isBusy = true;
                this.$emit('busy', true);

                try {
                    const res = await get('protocol', `control${this.protocolUrl}`);

                    this.$emit('created', res.data);
                } catch (e) {
                } finally {
                    this.isBusy = false;
                    this.$emit('busy', false);
                }
            }
        }
    };
</script>

